import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FeatureFlag } from '@app/enums';
import { BenefitDeductionFrequency } from '@app/models/payroll/company/benefit-deduction-frequency.model';
import { PayrollBenefitsMenuService } from '@app/modules/payroll/services/payroll-module-menu.service';
import { NotifyService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { BenefitType } from '@models/payroll/benefit-type.model';
import { CompanyBenefit } from '@models/payroll/company/benefit.model';

@Component({
    templateUrl: './benefit-show.template.html',
})
export class BenefitShowView implements OnInit {
    isLoading = true;
    benefit: CompanyBenefit = new CompanyBenefit();
    benefitType?: BenefitType;
    benefitDeductionFrequency?: BenefitDeductionFrequency;
    hasBenefitsPayroll = false;

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        private notify: NotifyService,
        private featureService: FeatureService,
        public payrollBenefitsMenuService: PayrollBenefitsMenuService
    ) {
        if (this.route.snapshot.data.models) {
            this.benefit = this.route.snapshot.data.models.get('benefit');

            this.loadBenefitType(this.benefit?.benefitType?.id);
            this.loadBenefitDeductionFrequency(this.benefit?.benefitDeductionFrequencyUuid);
        }
    }

    async ngOnInit(): Promise<void> {
        const hasBenefitsPayroll = await this.featureService.has(FeatureFlag.benefitsPayroll);
        this.hasBenefitsPayroll = hasBenefitsPayroll;
    }

    async onDelete(): Promise<void> {
        try {
            this.isLoading = true;

            await this.benefit?.delete();

            this.notify.success('success');
            this.router.navigate(['/payroll/benefits']);
        } catch (err) {
            this.isLoading = false;
            this.notify.error(err);
        }
    }

    onEdit(): void {
        this.router.navigate(['edit'], { relativeTo: this.route });
    }

    /**
     * Load the full benefit type model.
     */
    private async loadBenefitType(benefitTypeId?: number): Promise<void> {
        if (benefitTypeId) {
            this.benefitType = await BenefitType.find(benefitTypeId);
        }
        this.isLoading = false;
    }

    private async loadBenefitDeductionFrequency(benefitDeductionFrequencyUuid?: string): Promise<void> {
        if (benefitDeductionFrequencyUuid) {
            this.benefitDeductionFrequency = await BenefitDeductionFrequency.find(benefitDeductionFrequencyUuid);
        }
        this.isLoading = false;
    }
}
